import { useIsFocused } from "@react-navigation/native";
import { QrScanner } from "@yudiel/react-qr-scanner";
import { FormattedMessage } from "react-intl";

import * as Styled from "./styles";
import { useQrScanner } from "./hooks";

const Scanner: React.FC = () => {
  const isFocused = useIsFocused();
  const { $isValid, $isLoading, error, ticket, ...qrScanner } = useQrScanner();

  return (
    <Styled.Wrapper>
      <Styled.QrScannerContainer {...{ $isValid }}>
        {isFocused && <QrScanner {...qrScanner} />}
        <Styled.StatusIcon {...{ $isValid, $isLoading }} />
      </Styled.QrScannerContainer>
      {error && (
        <Styled.StatusMessage>
          <Styled.StatusMessageHeading>
            <FormattedMessage defaultMessage="Status:" />
            <Styled.StatusMessageValue>
              <FormattedMessage defaultMessage="Failed" />
            </Styled.StatusMessageValue>
          </Styled.StatusMessageHeading>
          <Styled.Description>{error}</Styled.Description>
        </Styled.StatusMessage>
      )}
      {ticket && (
        <Styled.StatusMessage>
          <Styled.StatusMessageHeading>
            <FormattedMessage defaultMessage="Status:" />
            <Styled.StatusMessageValue $isValid>
              <FormattedMessage defaultMessage="Success" />
            </Styled.StatusMessageValue>
          </Styled.StatusMessageHeading>
          <Styled.Description>
            <Styled.DescriptionLabel>
              <FormattedMessage defaultMessage="Ticket Type:" />
            </Styled.DescriptionLabel>
            {ticket.name}
          </Styled.Description>
          <Styled.Description>
            <Styled.DescriptionLabel>
              <FormattedMessage defaultMessage="Notes:" />
            </Styled.DescriptionLabel>
            {ticket.order?.customerNotes || "-"}
          </Styled.Description>
        </Styled.StatusMessage>
      )}
    </Styled.Wrapper>
  );
};

export default Scanner;
